import { Injectable, TemplateRef } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseControl, Custom, Textbox } from "@app/shared";
import { environment } from '@env/environment';

@Injectable()
export class StampFormService{
  // documentClassification?: ClasificacionPredeterminada
  constructor() { }

  
   /**
    *Construye y retorna el contro de los rótulos
    *
    * @param {*} [objectModel]
    * @return {*}  {BaseControl<any>[]}
    * @memberof StampFormService
    */
   getStickerForm(objectModel?: any): BaseControl<any>[] {
    if (environment.stickersAvanzados){
      const controls: BaseControl<any>[] = [
        new Textbox({
          key: 'nombre',
          value: objectModel ? objectModel.data ? objectModel.data.nombre ? objectModel.data.nombre : null : null : null,
          label: 'Nombre',
          placeholder: 'Nombre del rótulo',
          order: 1,
          validations: {
            validators: [Validators.required]
          }
        }),
        new Custom({
          key: 'rotulo',
          label: 'Rótulo',
          order: 2,
          template: objectModel.template
        }),
        new Textbox({
          key: 'posicion_x',
          value: objectModel ? objectModel.data ? objectModel.data.posicion_x ? objectModel.data.posicion_x : 0 : 0 : 0,
          label: 'Posición horisontal',
          type: 'number',
          placeholder: 'Posición horisontal del rotulo',
          order: 3,
          validations: {
            validators: [Validators.required]
          }
        }),
        new Textbox({
          key: 'posicion_y',
          value: objectModel ? objectModel.data ? objectModel.data.posicion_y ? objectModel.data.posicion_y : 0 : 0 : 0,
          label: 'Posición vertical',
          type: 'number',
          placeholder: 'Posición vertical del rotulo',
          order: 4,
          validations: {
            validators: [Validators.required]
          }
        }),
        new Textbox({
          key: 'ancho',
          value: objectModel ? objectModel.data ? objectModel.data.ancho ? objectModel.data.ancho : 0 : 0 : 0,
          label: 'Ancho',
          type: 'number',
          placeholder: 'Ancho de la imagen',
          order: 5,
          validations: {
            validators: [Validators.required]
          }
        }),
        new Custom({
          key: 'preview',
          label: '',
          order: 6,
          template: objectModel.preview
        }),
        new Textbox({
          key: 'impresion',
          order: 7,
          type: 'checkbox',
          value:  objectModel.data ? objectModel.data.imprimir : false,
          label: 'Tipo impresion',
          size: 'col-md-2'
        }),
      ];
      return controls.sort((a, b) => a.order - b.order);
    }else{
      const controls: BaseControl<any>[] = [
        new Textbox({
          key: 'nombre',
          value: objectModel ? objectModel.data ? objectModel.data.nombre ? objectModel.data.nombre : null : null : null,
          label: 'Nombre',
          placeholder: 'Nombre del rótulo',
          order: 1,
          validations: {
            validators: [Validators.required]
          }
        }),
        new Custom({
          key: 'rotulo',
          label: 'Rótulo',
          order: 2,
          template: objectModel.template
        })
      ];
      return controls.sort((a, b) => a.order - b.order);
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/administration/documents/stamp/shared/stamp-form.service.ts